const messages = {
    en: {
        message: {
            guestLogin: 'Or Login with User ID',
            inputUserId: 'Input Your 9 or 17 digit UserID',
            login: 'Login',
            loginWith: 'Login with',
            orLoginWith: 'Login With',
            userIDErrorTip: 'Error! Please enter the correct user ID.',
            userIDLengthError: '',
            logout: 'LOG OUT',
            logoutConfirmationTitle: 'LOGOUT CONFIRMATION',
            confirmLogout: 'ARE YOU SURE YOU WANT TO LOGOUT?',
            stayLoggedIn: 'STAY LOGGED IN',
            logMeOut: 'LOG ME OUT',
            yes: 'yes',
            cancel: 'cancel',
            extra: 'EXTRA',
            loading: 'loading',
            moreCoins: 'MORE COINS',
            free: 'FREE',
            freeWheel: 'FREE WHEEL',
            blackWheel: 'BLACK WHEEL',
            okay: 'COLLECT',
            goDrBingo:'GO DR BINGO',
            success: 'SUCCESS!',
            credited: 'YOU HAVE BEEN CREDITED! PLEASE CLICK "COLLECT" TO CLAIM IMMEDIATELY OR GO DR BINGO TO CHECK YOUR BALANCE!',
            regularCredited: 'YOU HAVE BEEN CREDITED! PLEASE CLICK "COLLECT" TO CLAIM IMMEDIATELY.',
            rollingCreditedFree: 'YOU HAVE BEEN CREDITED! PLEASE CLICK "COLLECT" TO CLAIM IMMEDIATELY. AND FREE REWARD WIILL BE ADDED TO YOUR ACCOUNT AUTOMATICALLY! ',
            rollingCredited: 'YOU HAVE BEEN CREDITED! PLEASE CLICK "COLLECT" TO CLAIM IMMEDIATELY.',
            paymentTitle: 'PAYMENT METHOD',
            paymentSubTitle: 'CHOOSE YOUR PAYMENT METHOD',
            pix: 'USE PIX',
            otherWays: 'CREDIT CARD, BOLETO <br/>AND OTHERS',
            paymentFailed: 'PAYMENT FAILURE',
            paymentFailureReason: "WE COULDN'T PROCESS YOUR PAYMENT. PLEASE TRY AGAIN OR USE ANOTHER PAYMENT METHOD",
            tryAgain: 'OK',
            securePaymentText: 'SECURE PAYMENT. YOUR DATA IS PROTECTED AND YOUR PURCHASE IS 100% SAFE.',
            footerSecure: '100% SECURE',
            footerPixPayment: 'PIX PAYMENT',
            footerNeedHelp: 'NEED HELP?',
            footerCheckOnDrBingo: 'PLEASE CHECK IT ON DR BINGO',
            openTheApp: 'OPEN THE APP',
            openAppTitle: 'OPEN THE APP AND CLICK THE ICON TO REDEEM!',
            openAppMegaWinTitle: 'DR. BINGO MEGA WIN IS LIVE!',
            openAppMegaWinSubtitle: 'Free spins + daily jackpots waiting for you!',
            openAppMegaWinCta: 'Install now and unlock your lucky reward chest!',
            airdropTitle: 'YOUR WEEKLY AIRDROP IS HERE!',
            airdropDescription: 'REDEEM IT AND GO CHECK INSIDE THE GAME YOUR PRIZES.',
            collectAirdrop: 'COLLECT',
            err_1002: 'Login failed. USERID does not exist',
            err_0001: 'Login failed. Please try again later',
            err_1003: 'Account blocked for purchasing. For more information, please contact our support at support@drbingo.com.',
            tutorialStep1: 'Click "settings" button in the upper right corner',
            tutorialStep2: 'Check your ID here and click "COPY" button to copy it',
            tutorialClose: 'Okay,I see',
            userIDTip: 'This is your User ID. Please, check it in Dr Bingo',
            buyFor: 'BUY FOR',
            bonusModalTitle: "we're sorry",
            bonusNotAvailable: "Bonus already claimed.",
            bonusExpired: "Bonus expired.",
            bonusNotFound: "Bonus ID not found.",
            bonusContinueButton: "Continue",
            prizeListTitle: "PLAY NOW",
            goButtonText: "GO",
            prizeHowToPlay: "HOW IT WORKS",
            prizePick: "Pick a prize",
            prizeToken: "Start with tokens",
            prizeClaw: "Control live claw",
            prizeWin: "Win rewards",
            prizeChoose: "CLICK BELOW TO GET STARTED",
            prizeFeature: "FEATURES",
            prizeLiveGame: "LIVE VIDEO",
            prizeRealTime: "REAL-TIME CONTROLS",
            prizeBalance: "FAIR CHANCES",
            prizeWebstore: "EXCLUSIVE TO THE ONLINE STORE",
        }
    },
    es: {
        message: {
            guestLogin: 'O utilice el ID de Usuario para iniciar sesión',
            inputUserId: 'Ingrese su ID de usuario de 9 o 17 dígitos',
            login: 'Iniciar',
            loginWith: 'Inicia con',
            orLoginWith: 'Inicia con',
            userIDErrorTip: '¡Identificación invalida! Por favor ingrese la identificación correcta',
            userIDLengthError: '',
            logout: 'SALIR',
            logoutConfirmationTitle: 'CONFIRMACIÓN DE CIERRE DE SESIÓN',
            confirmLogout: '¿ESTÁ SEGURO DE QUE DESEA CERRAR SESIÓN?',
            stayLoggedIn: 'PERMANECER CONECTADO',
            logMeOut: 'CERRAR MI SESIÓN',
            yes: 'Sí',
            cancel: 'Cancelar',
            extra: 'EXTRA',
            loading: 'cargando',
            moreCoins: 'MÁS MONEDAS',
            free: 'GRATIS',
            freeWheel: 'RULETA GRATIS',
            blackWheel: 'RULETA BLACK',
            okay: 'RECOGER',
            goDrBingo:'ACCEDE A DR.BINGO',
            success: '¡ÉXITO!',
            credited: '¡USTED HA SIDO CRÉDITO! PARA CONSULTAR TU SALDO HAZ CLICK EN “COBRAR” O ACCEDE DIRECTAMENTE A DR BINGO!',
            regularCredited: '¡HAS RECIBIDO TUS CRÉDITOS! HAZ CLIC EN "COBRAR" PARA RECIBIRLOS DE INMEDIATO.',
            rollingCreditedFree: '¡HAS RECIBIDO TUS CRÉDITOS! HAZ CLIC EN "COBRAR" PARA RECIBIRLOS DE INMEDIATO. TU RECOMPENSA GRATIS SE ACREDITARÁ AUTOMÁTICAMENTE EN TU CUENTA.',
            rollingCredited: '¡HAS RECIBIDO TUS CRÉDITOS! HAZ CLIC EN "COBRAR" PARA RECIBIRLOS DE INMEDIATO.',
            paymentTitle: 'MÉTODO DE PAGO',
            paymentSubTitle: 'ELIGE TU MÉTODO DE PAGO',
            pix: 'USE PIX',
            otherWays: 'TARJETA DE CRÉDITO, <br/>BOLETO Y OTROS',
            paymentFailed: 'PAGO FALLIDO',
            paymentFailureReason: "WE COULDN'T PROCESS YOUR PAYMENT. PLEASE TRY AGAIN OR USE ANOTHER PAYMENT METHOD",
            tryAgain: 'OK',
            securePaymentText: 'PAGO SEGURO. TUS DATOS ESTÁN PROTEGIDOS Y TU COMPRA ES 100% SEGURA.',
            footerSecure: '100% SEGURO',
            footerPixPayment: 'PAGO PIX',
            footerNeedHelp: 'NECESITAS AYUDA?',
            footerCheckOnDrBingo: 'POR FAVOR REVÍSALO EN DR BINGO',
            openTheApp: 'ABRE LA APP',
            openAppTitle: '¡ABRE LA APP HAZA CLIC EN EL ICONO PARA REDIMIR!',
            openAppMegaWinTitle: 'DR. BINGO MEGA WIN JÁ ESTÁ NO AR!',
            openAppMegaWinSubtitle: 'Giros grátis + jackpots diários esperando por você!',
            airdropTitle: '¡TU AIRDROP SEMANAL ESTÁ AQUÍ!',
            airdropDescription: 'CANJÉALO Y VE ADENTRO DEL JUEGO PARA VER TUS PREMIOS.',
            collectAirdrop: 'RECOPILAR',
            err_1002: 'Falló el inicio de sesión. Esta ID de usuario no existe',
            err_0001: 'Falló el inicio de sesión. Por favor, inténtelo de nuevo más tarde',
            err_1003: 'Cuenta bloqueada para realizar compras. Para más información, por favor, ponte en contacto con nuestro soporte en support@drbingo.com.',
            tutorialStep1: 'Haga clic en el botón "configuración" en la esquina superior derecha',
            tutorialStep2: 'Comprueba aquí tu ID y haz clic en el botón "COPIAR"',
            tutorialClose: 'Bueno',
            userIDTip: 'Esta es su ID de usuario. Por favor, revisa la información dentro de Dr.Bingo',
            buyFor: 'COMPRE',
            bonusModalTitle: "Lo sentimos",
            bonusNotAvailable: "Bonus ya reclamado.",
            bonusExpired: "Bonus vencido.",
            bonusNotFound: "ID de Bonus no encontrado.",
            bonusContinueButton: "Continuar",
            prizeListTitle: "JOGUE AGORA",
            goButtonText: "JOGAR",
            prizeHowToPlay: "COMO FUNCIONA",
            prizePick: "Escolha um prêmio",
            prizeToken: "Use fichas",
            prizeClaw: "Controle ao vivo",
            prizeWin: "Ganhe recompensas",
            prizeChoose: "CLIQUE ABAIXO PARA COMEÇAR",
            prizeFeature: "DESTAQUES",
            prizeLiveGame: "VÍDEO AO VIVO",
            prizeRealTime: "CONTROLE EM TEMPO REAL",
            prizeBalance: "CHANCES EQUILIBRADAS",
            prizeWebstore: "EXCLUSIVO DA LOJA ONLINE",
        }
    },
    pt: {
        message: {
            guestLogin: 'Ou use ID de Usuário para entrar',
            inputUserId: 'Insira o seu ID de usuário de 9 ou 17 dígitos',
            login: 'Entrar',
            loginWith: 'Entrar com',
            orLoginWith: 'Entrar com',
            userIDErrorTip: 'ID Inválido! Por favor, digite o ID correto',
            userIDLengthError: '',
            logout: 'SAIR',
            logoutConfirmationTitle: 'CONFIRMAÇÃO DE SAÍDA',
            confirmLogout: 'TEM CERTEZA DE QUE DESEJA SAIR?',
            stayLoggedIn: 'CONTINUAR CONECTADO',
            logMeOut: 'SAIR DA CONTA',
            yes: 'Sim',
            cancel: 'Cancelar',
            extra: 'EXTRA',
            loading: 'carregando',
            moreCoins: 'MAIS MOEDAS',
            free: 'GRÁTIS',
            freeWheel: 'ROLETA GRÁTIS',
            blackWheel: 'ROLETA BLACK',
            okay: 'COLETAR',
            goDrBingo:'ACESSE O DR.BINGO',
            success: 'PARABÉNS',
            credited: 'VOCÊ FOI CREDITADO! PARA VERIFICAR O SEU SALDO CLIQUE EM "COLETAR" OU ACESSE DIRETAMENTE O DR BINGO!',
            regularCredited: 'VOCÊ RECEBEU SEUS CRÉDITOS! CLIQUE EM "COLETAR" PARA RECEBÊ-LOS IMEDIATAMENTE.',
            rollingCreditedFree: 'VOCÊ RECEBEU SEUS CRÉDITOS! CLIQUE EM "COLETAR" PARA RECEBÊ-LOS IMEDIATAMENTE. SUA RECOMPENSA GRÁTIS SERÁ CREDITADA AUTOMATICAMENTE EM SUA CONTA.',
            rollingCredited: 'VOCÊ RECEBEU SEUS CRÉDITOS! CLIQUE EM "COLETAR" PARA RECEBÊ-LOS IMEDIATAMENTE.',
            paymentTitle: 'MÉTODO DE PAGAMENTO',
            paymentSubTitle: 'ESCOLHA SEU MÉTODO DE PAGAMENTO',
            pix: 'USAR PIX',
            otherWays: 'CARTÃO, BOLETO <br/>E OUTROS',
            paymentFailed: 'FALHA NO PAGAMENTO',
            paymentFailureReason: 'NÃO FOI POSSÍVEL PROCESSAR SEU PAGAMENTO. TENTE NOVAMENTE OU USE OUTRO MÉTODO DE PAGAMENTO.',
            tryAgain: 'OK',
            securePaymentText: 'PAGAMENTO SEGURO. SEUS DADOS ESTÃO PROTEGIDOS E SUA COMPRA É 100% SEGURA.',
            footerSecure: '100% SEGURO',
            footerPixPayment: 'PAGAMENTO VIA PIX',
            footerNeedHelp: 'PRECISA DE AJUDA?',
            footerCheckOnDrBingo: 'CONFIRA NO DR. BINGO',
            openTheApp: 'ABRIR O APP',
            openAppTitle: 'ABRA O APP E CLIQUE NO ÍCONE PARA RESGATAR!',
            openAppMegaWinTitle: 'DR. BINGO MEGA WIN JÁ ESTÁ NO AR!',
            openAppMegaWinSubtitle: 'Giros grátis + jackpots diários esperando por você!',
            openAppMegaWinCta: 'Instale agora e desbloqueie seu Baú da Sorte!',
            airdropTitle: 'SEU AIRDROP SEMANAL CHEGOU!',
            airdropDescription: 'RESGATE E CONFIRA SEUS PRÊMIOS NO JOGO.',
            collectAirdrop: 'COLETAR',
            err_1002: 'Falha no login. Este ID de usuário não existe',
            err_0001: 'Falha no login. Por favor, tente novamente mais tarde',
            err_1003: 'Conta bloqueada para realização de compras. Para mais informações, por favor, entre em contato com nosso suporte pelo endereço support@drbingo.com.',
            tutorialStep1: 'Clique no botão de "configurações" no canto superior direito',
            tutorialStep2: 'Cheque seu ID aqui e clique no botão "COPIAR"',
            tutorialClose: 'Ok,eu entendo',
            userIDTip: 'Esse é o seu ID de Usuário. Por favor, verifique dentro do Dr.Bingo',
            buyFor: 'COMPRE',
            bonusModalTitle: "Sentimos muito",
            bonusNotAvailable: "Bônus já Recolhido.",
            bonusExpired: "Bônus Expirado.",
            bonusNotFound: "Bônus não Encontrado.",
            bonusContinueButton: "Continuar",
            prizeListTitle: "JOGUE AGORA",
            goButtonText: "JOGAR",
            prizeHowToPlay: "COMO FUNCIONA",
            prizePick: "Escolha um prêmio",
            prizeToken: "Use fichas",
            prizeClaw: "Controle ao vivo",
            prizeWin: "Ganhe recompensas",
            prizeChoose: "CLIQUE ABAIXO PARA COMEÇAR",
            prizeFeature: "DESTAQUES",
            prizeLiveGame: "VÍDEO AO VIVO",
            prizeRealTime: "CONTROLE EM TEMPO REAL",
            prizeBalance: "CHANCES EQUILIBRADAS",
            prizeWebstore: "EXCLUSIVO DA LOJA ONLINE",
        }
    }
}

export default messages



// WEBPACK FOOTER //
// ./src/i18n.js